export default __webpack_public_path__ + "static/media/team.0e05710f.svg";